import { useEffect, useState } from 'react'
import { calculateElapsed } from '@/lib/dates'

export function useLiveElapsed(clockIn: string, intervalMs = 60_000) {
    const [elapsed, setElapsed] = useState(() => calculateElapsed(clockIn))

    useEffect(() => {
        setElapsed(calculateElapsed(clockIn))
        const id = setInterval(() => setElapsed(calculateElapsed(clockIn)), intervalMs)
        return () => clearInterval(id)
    }, [clockIn, intervalMs])

    return elapsed
}
